(function () {
  'use strict';

  function getEmbed(url) {
    if (!url) return null;

    let match;

    match = url.match(
      /(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/shorts\/)([^?&/]+)/
    );

    if (match && match[1]) {
      return {
        type: 'iframe',
        src:
          'https://www.youtube.com/embed/' +
          match[1] +
          '?autoplay=1&rel=0'
      };
    }

    match = url.match(
      /vimeo\.com\/(?:video\/)?(\d+)/
    );

    if (match && match[1]) {
      return {
        type: 'iframe',
        src:
          'https://player.vimeo.com/video/' +
          match[1] +
          '?autoplay=1'
      };
    }

    return {
      type: 'video',
      src: url
    };
  }


  function openVideo(section, url) {
    const dialog =
      section.querySelector(
        '[data-lw-social-dialog]'
      );

    const stage =
      section.querySelector(
        '[data-lw-social-video-stage]'
      );

    if (!dialog || !stage || !url) {
      return;
    }

    const embed =
      getEmbed(url);

    if (!embed) return;

    stage.innerHTML = '';

    if (embed.type === 'iframe') {
      const iframe =
        document.createElement('iframe');

      iframe.src =
        embed.src;

      iframe.allow =
        'autoplay; fullscreen; picture-in-picture';

      iframe.allowFullscreen =
        true;

      iframe.title =
        'Customer video review';

      stage.appendChild(
        iframe
      );
    } else {
      const video =
        document.createElement('video');

      video.src =
        embed.src;

      video.controls =
        true;

      video.autoplay =
        true;

      video.playsInline =
        true;

      stage.appendChild(
        video
      );
    }

    if (
      typeof dialog.showModal ===
      'function'
    ) {
      dialog.showModal();
    } else {
      dialog.setAttribute(
        'open',
        ''
      );
    }
  }


  function closeVideo(dialog) {
    if (!dialog) return;

    const stage =
      dialog.querySelector(
        '[data-lw-social-video-stage]'
      );

    if (stage) {
      stage.innerHTML = '';
    }

    if (
      typeof dialog.close ===
      'function'
    ) {
      dialog.close();
    } else {
      dialog.removeAttribute(
        'open'
      );
    }
  }


  document.addEventListener(
    'click',
    function (event) {
      const opener =
        event.target.closest(
          '[data-lw-social-video-open]'
        );

      if (opener) {
        event.preventDefault();

        const section =
          opener.closest(
            '[data-lw-social-proof]'
          );

        if (!section) return;

        openVideo(
          section,
          opener.dataset.videoUrl
        );

        return;
      }

      const closer =
        event.target.closest(
          '[data-lw-social-dialog-close]'
        );

      if (closer) {
        closeVideo(
          closer.closest(
            '[data-lw-social-dialog]'
          )
        );
      }
    }
  );


  document.addEventListener(
    'click',
    function (event) {
      const dialog =
        event.target.closest &&
        event.target.closest(
          '[data-lw-social-dialog]'
        );

      if (
        dialog &&
        event.target === dialog
      ) {
        closeVideo(dialog);
      }
    }
  );

})();